/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChannelListItemViewModel } from "../types/ChannelListItemViewModel.ts";
import { ePlayerTypeSchema } from "./ePlayerTypeSchema.ts";

export const channelListItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do canal.")),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa do canal. Nulo para canais globais.")
    .nullish(),
  companyName: z
    .string()
    .describe("Nome da empresa do canal. Vazio para canais globais.")
    .nullish(),
  channelName: z
    .string()
    .describe("Nome do canal. Máximo de 20 caracteres.")
    .nullish(),
  channelCode: z
    .string()
    .describe(
      "Código de incorporação do canal, gravado verbatim como no legado.",
    )
    .nullish(),
  videoVimeoId: z
    .string()
    .describe("ID do vídeo no Vimeo. Opcional.")
    .nullish(),
  playerType: z.optional(
    z
      .lazy(() => ePlayerTypeSchema)
      .describe("1 = Vimeo | 2 = YouTube | 3 = JWPlayer | 4 = Others | "),
  ),
  liveStreamLink: z
    .string()
    .describe("Link de transmissão ao vivo. Opcional.")
    .nullish(),
  videoDuration: z
    .number()
    .int()
    .describe(
      "Duração da mídia, em minutos. Opcional — 7.683 canais da base não têm duração gravada.",
    )
    .nullish(),
  isAudio: z.optional(z.boolean().describe("Indica se o canal é de áudio.")),
  isSubtitling: z.optional(
    z.boolean().describe("Indica se o canal tem legendagem."),
  ),
  isInternational: z.optional(
    z.boolean().describe("Indica se o canal é internacional."),
  ),
  recordVideoTime: z.optional(
    z
      .boolean()
      .describe("Indica se a posição de reprodução do aluno é registrada."),
  ),
  active: z.optional(z.boolean().describe("Indica se o canal está ativo.")),
  hasEmbedPreview: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o código do canal pode ser pré-visualizado: falso para canal de áudio ou quando o código contém script. No legado essa checagem era feita no JavaScript do grid e falhava quando o código começava com a palavra script.",
      ),
  ),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<ChannelListItemViewModel>;
